/* Реєстри (/registers, docs/processes C9). Kept apart from uk.ts/en.ts to keep merges small. */
export const registersUk = {
  'nav.registers': 'Реєстри',
  'perm.registers.read': 'Реєстри: перегляд, обхід, поломки',
  'perm.registers.manage': 'Реєстри: редагування, переміщення, імпорт',
  'registers.title': 'Реєстри',
  'registers.subtitle': 'Основні засоби, вогнегасники, рентген, дозволи, договори, страховки, кореспонденція — зі строками, QR-наклейками та історією',
  'registers.walk': 'Обхід',
  'registers.import': 'Імпорт CSV',
  'registers.new': 'Запис',
  'registers.tab.all': 'Усі',
  'registers.tab.expiring': 'Строки',
  'registers.noTypes': 'Реєстрів ще немає',
  'registers.noTypesHint': 'Додайте стандартні реєстри з документів клініки — їх можна змінити пізніше.',
  'registers.noTypesStaff': 'Попросіть адміністратора додати реєстри.',
  'registers.seed': 'Додати стандартні реєстри',
  'registers.empty': 'У реєстрі ще немає записів',
  'registers.emptyHint': 'Додайте запис вручну або завантажте наявну таблицю через «Імпорт CSV».',
  'registers.emptyStaff': 'Записи додає адміністратор; тут з’являться позиції з наклейками й строками.',
  'registers.search': 'Номер, назва, місце…',
  'registers.allBranches': 'Усі філії',
  'registers.filter.current': 'Чинні',
  'registers.filter.retired': 'Списані й закриті',
  'registers.filter.all': 'Усі статуси',
  'registers.filter.expiring': 'Спливає строк',
  'registers.filter.missing': 'Бракує документів',
  'registers.filter.mine': 'Я відповідальний',
  'registers.printLabels': 'Друк QR',
  'registers.code': 'Номер',
  'registers.name': 'Назва',
  'registers.nameHint': 'Порожньо — з моделі / кореспондента',
  'registers.type': 'Реєстр',
  'registers.branch': 'Філія',
  'registers.noBranch': 'Не вказано',
  'registers.location': 'Приміщення',
  'registers.locationHint': 'Напр. «Хірургія №1», «Рентген»',
  'registers.place': 'Де',
  'registers.noPlace': 'Місце не вказано',
  'registers.responsible': 'Відповідальний',
  'registers.responsibleNone': 'Немає (нагадування — адміністраторам)',
  'registers.responsibleName': 'Відповідальний (текстом)',
  'registers.status': 'Статус',
  'registers.notes': 'Примітки',
  'registers.nearestDeadline': 'Найближчий строк',
  'registers.autoCode': 'Порожньо — наступний номер {prefix}…',
  'registers.leadHint': 'Нагадування за {days} дн. і в день строку',
  'registers.newTitle': 'Новий запис: {type}',
  'registers.editTitle': 'Редагувати запис',
  'registers.saved': 'Збережено',
  'registers.moneyHidden': 'Суми бачать лише користувачі з доступом до оплат.',
  'registers.status.active': 'Використовується',
  'registers.status.reserve': 'Резерв',
  'registers.status.unused': 'Не використовується',
  'registers.status.broken': 'Несправне',
  'registers.status.repair': 'У ремонті',
  'registers.status.forbidden': 'Заборонено до експлуатації',
  'registers.status.written_off': 'Списано',
  'registers.status.closed': 'Закрито',
  'registers.daysLeft': 'через {n} день|через {n} дні|через {n} днів',
  'registers.daysOverdue': 'прострочено на {n} день|прострочено на {n} дні|прострочено на {n} днів',
  'registers.today': 'сьогодні',
  'registers.overdue': 'Прострочено',
  'registers.missingCount': 'бракує {n} документа|бракує {n} документів|бракує {n} документів',
  'registers.missingTitle': 'Бракує обов’язкових документів',
  'registers.detail': 'Запис реєстру',
  'registers.check': 'Перевірити',
  'registers.checkMissing': 'Не знайдено під час обходу',
  'registers.checkAttention': 'Потребує уваги',
  'registers.breakdown': 'Поломка',
  'registers.transfer': 'Перемістити',
  'registers.qr': 'QR-наклейка',
  'registers.deadlines': 'Строки',
  'registers.lastCheck': 'Остання перевірка',
  'registers.neverChecked': 'ще не перевіряли',
  'registers.openLink': 'Відкрити',
  'registers.incidents': 'Поломки (інциденти)',
  'registers.runs': 'Чеклісти',
  'registers.history': 'Історія',
  'registers.notePlaceholder': 'Нотатка: що зроблено, що змінилось',
  'registers.addNote': 'Додати',
  'registers.noteAdded': 'Нотатку додано',
  'registers.system': 'Система',
  'registers.ev.created': 'Створено',
  'registers.ev.imported': 'Імпортовано з таблиці',
  'registers.ev.updated': 'Змінено',
  'registers.ev.moved': 'Переміщено: {from} → {to}',
  'registers.ev.status': 'Статус: {from} → {to}',
  'registers.ev.repaired': 'Відремонтовано: {from} → {to}',
  'registers.ev.broken': 'Поломка, інцидент №{n}',
  'registers.ev.checked': 'Перевірено під час обходу',
  'registers.ev.checkedAttention': 'Перевірено — потребує уваги',
  'registers.ev.missing': 'Не знайдено під час обходу',
  'registers.ev.note': 'Нотатка',
  'registers.ev.serviced': 'Обслуговування',
  'registers.ev.run': 'Створено чекліст',
  'registers.transferTitle': 'Перемістити',
  'registers.transferHint': 'Переміщення між філіями чи приміщеннями зберігається в історії: звідки, куди, коли й хто.',
  'registers.transferNote': 'Коментар',
  'registers.transferNoteHint': 'Хто передав, хто прийняв, причина',
  'registers.moved': 'Переміщення записано',
  'registers.breakdownTitle': 'Повідомити про поломку',
  'registers.breakdownHint': '«{item}»: буде створено технічний інцидент — відповідальні отримають сповіщення.',
  'registers.breakdownBody': 'Що зламалось',
  'registers.breakdownPlaceholder': 'Що не працює, з якого часу, чи можна користуватись',
  'registers.breakdownType': 'Тип інциденту',
  'registers.breakdownSend': 'Повідомити',
  'registers.breakdownSent': 'Інцидент №{n} створено',
  'registers.forbid': 'Заборонити експлуатацію до ремонту',
  'registers.qrTitle': 'QR-наклейка',
  'registers.qrHint': 'Скануйте камерою телефона — відкриється перевірка цієї позиції.',
  'registers.print': 'Друкувати',
  'registers.labelsTitle': 'QR-наклейки',
  'registers.labelsHint': 'Надрукуйте й наклейте на обладнання: QR відкриває обхід із цією позицією.',
  'registers.labelsEmpty': 'Немає позицій для друку',
  'registers.importTitle': 'Імпорт таблиці (CSV)',
  'registers.importHint': 'Збережіть аркуш Google Таблиці як CSV (Файл → Завантажити → CSV). Колонки розпізнаються за назвою; спершу перевірте, потім імпортуйте.',
  'registers.importFile': 'Файл CSV',
  'registers.importFileHint': 'Перший рядок — назви колонок',
  'registers.importColumns': 'Колонки',
  'registers.importCheck': 'Перевірити',
  'registers.importRun': 'Імпортувати',
  'registers.importDry': 'Перевірка',
  'registers.importDone': 'Імпортовано',
  'registers.importStats': 'Рядків: {rows} · нових: {created} · оновлено: {updated} · пропущено: {skipped}',
  'registers.importIgnored': 'Колонку пропущено',
  'registers.importDuplicates': 'Номери повторюються',
  'registers.importRow': 'Рядок {n}',
  'registers.imported': 'Імпортовано: нових {created}, оновлено {updated}',
  'registers.horizon': 'Період',
  'registers.horizonDays': 'на {n} днів',
  'registers.noDeadlines': 'Строків найближчим часом немає',
  'registers.noDeadlinesHint': 'Тут з’являться дати перезарядки, повірок, ліцензій, договорів і полісів, а також планові перевірки.',
  'registers.openRun': 'Чекліст',
  'registers.walkTitle': 'Обхід',
  'registers.walkHint': 'Скануйте QR-наклейку камерою телефона або введіть номер з наклейки.',
  'registers.walkPlaceholder': 'Номер з наклейки або посилання з QR',
  'registers.walkOpen': 'Відкрити',
  'registers.walkEmpty': 'Відскануйте першу позицію',
  'registers.walkEmptyHint': 'Після перевірки сторінка готова до наступної наклейки.',
  'registers.walkNotFound': 'Позицію не знайдено',
  'registers.walkNotFoundHint': 'Перевірте номер або додайте позицію в реєстр (адміністратор).',
  'registers.walkSeveral': 'Цей номер є в кількох реєстрах — оберіть:',
  'registers.walkChecklist': 'Перевірка',
  'registers.walkLocation': 'Де стоїть насправді',
  'registers.walkLocationHint': 'Змініть, якщо позиція в іншому приміщенні — переміщення запишеться',
  'registers.walkNote': 'Коментар',
  'registers.walkOk': 'Перевірено',
  'registers.walkNotFoundBtn': 'Не знайдено',
  'registers.walkRequired': 'Дайте відповідь на обов’язкові пункти: {n}',
  'registers.walkChecked': '«{item}» перевірено',
  'registers.walkMissingSaved': 'Відмічено: не знайдено',
  'today.expiringRegisters': 'Строки в реєстрах',
  'today.noExpiringRegisters': 'Найближчі 30 днів нічого не спливає',
}

export const registersEn: { [K in keyof typeof registersUk]?: string } = {
  'nav.registers': 'Registers',
  'perm.registers.read': 'Registers: view, walk, breakdowns',
  'perm.registers.manage': 'Registers: edit, move, import',
  'registers.title': 'Registers',
  'registers.subtitle': 'Assets, fire extinguishers, X-ray, permits, contracts, insurance, correspondence — with deadlines, QR labels and history',
  'registers.walk': 'Walk',
  'registers.import': 'Import CSV',
  'registers.new': 'Item',
  'registers.tab.all': 'All',
  'registers.tab.expiring': 'Deadlines',
  'registers.noTypes': 'No registers yet',
  'registers.noTypesHint': 'Add the default registers from the clinic documents — you can change them later.',
  'registers.noTypesStaff': 'Ask an administrator to add the registers.',
  'registers.seed': 'Add default registers',
  'registers.empty': 'This register is empty',
  'registers.emptyHint': 'Add an item or upload the existing sheet with «Import CSV».',
  'registers.emptyStaff': 'Items are added by an administrator; labelled items with deadlines will appear here.',
  'registers.search': 'Number, name, room…',
  'registers.allBranches': 'All branches',
  'registers.filter.current': 'Current',
  'registers.filter.retired': 'Written off and closed',
  'registers.filter.all': 'All statuses',
  'registers.filter.expiring': 'Deadline soon',
  'registers.filter.missing': 'Documents missing',
  'registers.filter.mine': 'I am responsible',
  'registers.printLabels': 'Print QR',
  'registers.code': 'Number',
  'registers.name': 'Name',
  'registers.nameHint': 'Empty — from the model / correspondent',
  'registers.type': 'Register',
  'registers.branch': 'Branch',
  'registers.noBranch': 'Not set',
  'registers.location': 'Room',
  'registers.locationHint': 'E.g. «Surgery 1», «X-ray»',
  'registers.place': 'Where',
  'registers.noPlace': 'No place set',
  'registers.responsible': 'Responsible',
  'registers.responsibleNone': 'Nobody (administrators are reminded)',
  'registers.responsibleName': 'Responsible (text)',
  'registers.status': 'Status',
  'registers.notes': 'Notes',
  'registers.nearestDeadline': 'Nearest deadline',
  'registers.autoCode': 'Empty — next number {prefix}…',
  'registers.leadHint': 'Reminders {days} days before and on the date',
  'registers.newTitle': 'New item: {type}',
  'registers.editTitle': 'Edit item',
  'registers.saved': 'Saved',
  'registers.moneyHidden': 'Amounts are visible only with access to payments.',
  'registers.status.active': 'In use',
  'registers.status.reserve': 'Reserve',
  'registers.status.unused': 'Not used',
  'registers.status.broken': 'Broken',
  'registers.status.repair': 'In repair',
  'registers.status.forbidden': 'Forbidden to use',
  'registers.status.written_off': 'Written off',
  'registers.status.closed': 'Closed',
  'registers.daysLeft': 'in {n} day|in {n} days|in {n} days',
  'registers.daysOverdue': '{n} day overdue|{n} days overdue|{n} days overdue',
  'registers.today': 'today',
  'registers.overdue': 'Overdue',
  'registers.missingCount': '{n} document missing|{n} documents missing|{n} documents missing',
  'registers.missingTitle': 'Required documents are missing',
  'registers.detail': 'Register item',
  'registers.check': 'Check',
  'registers.checkMissing': 'Not found on the walk',
  'registers.checkAttention': 'Needs attention',
  'registers.breakdown': 'Breakdown',
  'registers.transfer': 'Move',
  'registers.qr': 'QR label',
  'registers.deadlines': 'Deadlines',
  'registers.lastCheck': 'Last check',
  'registers.neverChecked': 'never checked',
  'registers.openLink': 'Open',
  'registers.incidents': 'Breakdowns (incidents)',
  'registers.runs': 'Checklists',
  'registers.history': 'History',
  'registers.notePlaceholder': 'Note: what was done, what changed',
  'registers.addNote': 'Add',
  'registers.noteAdded': 'Note added',
  'registers.system': 'System',
  'registers.ev.created': 'Created',
  'registers.ev.imported': 'Imported from the sheet',
  'registers.ev.updated': 'Changed',
  'registers.ev.moved': 'Moved: {from} → {to}',
  'registers.ev.status': 'Status: {from} → {to}',
  'registers.ev.repaired': 'Repaired: {from} → {to}',
  'registers.ev.broken': 'Breakdown, incident #{n}',
  'registers.ev.checked': 'Checked on the walk',
  'registers.ev.checkedAttention': 'Checked — needs attention',
  'registers.ev.missing': 'Not found on the walk',
  'registers.ev.note': 'Note',
  'registers.ev.serviced': 'Service',
  'registers.ev.run': 'Checklist created',
  'registers.transferTitle': 'Move',
  'registers.transferHint': 'Moves between branches or rooms are kept in the history: from, to, when and by whom.',
  'registers.transferNote': 'Comment',
  'registers.transferNoteHint': 'Who handed over, who received, why',
  'registers.moved': 'Move recorded',
  'registers.breakdownTitle': 'Report a breakdown',
  'registers.breakdownHint': '«{item}»: a technical incident is created — the owners are notified.',
  'registers.breakdownBody': 'What is broken',
  'registers.breakdownPlaceholder': 'What does not work, since when, can it be used',
  'registers.breakdownType': 'Incident type',
  'registers.breakdownSend': 'Report',
  'registers.breakdownSent': 'Incident #{n} created',
  'registers.forbid': 'Forbid use until repaired',
  'registers.qrTitle': 'QR label',
  'registers.qrHint': 'Scan with a phone camera — the check of this item opens.',
  'registers.print': 'Print',
  'registers.labelsTitle': 'QR labels',
  'registers.labelsHint': 'Print and stick on the equipment: the QR opens the walk with the item.',
  'registers.labelsEmpty': 'Nothing to print',
  'registers.importTitle': 'Import a sheet (CSV)',
  'registers.importHint': 'Save the Google Sheets tab as CSV (File → Download → CSV). Columns are recognised by name; check first, then import.',
  'registers.importFile': 'CSV file',
  'registers.importFileHint': 'The first row holds the column names',
  'registers.importColumns': 'Columns',
  'registers.importCheck': 'Check',
  'registers.importRun': 'Import',
  'registers.importDry': 'Check',
  'registers.importDone': 'Imported',
  'registers.importStats': 'Rows: {rows} · new: {created} · updated: {updated} · skipped: {skipped}',
  'registers.importIgnored': 'Column ignored',
  'registers.importDuplicates': 'Repeated numbers',
  'registers.importRow': 'Row {n}',
  'registers.imported': 'Imported: {created} new, {updated} updated',
  'registers.horizon': 'Period',
  'registers.horizonDays': 'next {n} days',
  'registers.noDeadlines': 'No deadlines soon',
  'registers.noDeadlinesHint': 'Recharge, verification, licence, contract and policy dates and planned checks appear here.',
  'registers.openRun': 'Checklist',
  'registers.walkTitle': 'Walk',
  'registers.walkHint': 'Scan a QR label with the phone camera or type the number from the label.',
  'registers.walkPlaceholder': 'Label number or QR link',
  'registers.walkOpen': 'Open',
  'registers.walkEmpty': 'Scan the first item',
  'registers.walkEmptyHint': 'After each check the page is ready for the next label.',
  'registers.walkNotFound': 'Item not found',
  'registers.walkNotFoundHint': 'Check the number or ask an administrator to add the item.',
  'registers.walkSeveral': 'This number is in several registers — pick one:',
  'registers.walkChecklist': 'Check',
  'registers.walkLocation': 'Where it actually is',
  'registers.walkLocationHint': 'Change it if the item is in another room — the move is recorded',
  'registers.walkNote': 'Comment',
  'registers.walkOk': 'Checked',
  'registers.walkNotFoundBtn': 'Not found',
  'registers.walkRequired': 'Answer the required items: {n}',
  'registers.walkChecked': '«{item}» checked',
  'registers.walkMissingSaved': 'Marked as not found',
  'today.expiringRegisters': 'Register deadlines',
  'today.noExpiringRegisters': 'Nothing expires in the next 30 days',
}
